commusoftCommon.directive('csmodalaidelete', ['prefix', '$http', '$modal',function(prefix, $http, $modal) {
    return {
        transclude: true,
        replace: true,
        restrict: 'E',
        scope: {
            title: '@',
            deleteUrl: '@',
            deleteParams: '@',
            textToConfirm: '@',
            buttonClass: '@',
            buttonValue: '@',
            validationMessage: '@',
            isDefaultValue: '=',
            accountId: '=',
            shouldBeOpenAiDelete: '=',
            deleteFunc: '&',
            screenName: '@'
        },
        controller: function($scope, $element, $attrs, $transclude) {
            $scope.$watch('shouldBeOpenAiDelete', function(newVal, oldVal, scope) {
                var modalInstance = null;
                if (newVal == true) {
                    var elem = $transclude($scope, function() {});
                    $scope.transData = elem;

                    modalInstance = $modal.open({
                        templateUrl: 'template/delete/delete_accounting_integration.html',
                        scope: $scope,
                        controller: CSAIDeleteModalCtrl
                    })
                }
            });
        }
    }
}]);